import { SystemResources } from './../models/system-resources';
import { callBackendApi } from "src/components/service/axios";

export const fetchAllSystemResources = async (): Promise<SystemResources> => {
  return await callBackendApi("get", "/bff/system-resources");
};
